import { styled } from 'styled-components';

export const HalfSpaceTile = styled.div`
  width: calc(50% - 16px);
  float: left;
  margin-right: ${({ theme }) => theme.sizing.medium};
  min-width: 450px;
`;
HalfSpaceTile.displayName = 'HalfSpaceTile';

export const RouteTreeHolder = styled.div`
  padding-bottom: ${({ theme }) => theme.sizing.medium};
  width: 100%;
  svg {
    max-width: 700px;
    margin: 0px auto;
  }
`;
RouteTreeHolder.displayName = 'RouteTreeHolder';
